import { createContext, useCallback, useContext, useRef, type ReactNode } from 'react';

type FocusCanvasOnNode = (nodeId: string) => void;
type RegisterFocusCanvas = (fn: FocusCanvasOnNode | null) => void;

interface CanvasFocusContextValue {
  focusCanvasOnSelectedNode: FocusCanvasOnNode;
  registerFocusCanvas: RegisterFocusCanvas;
}

const noop = () => {};

const CanvasFocusContext = createContext<CanvasFocusContextValue>({
  focusCanvasOnSelectedNode: noop,
  registerFocusCanvas: () => {},
});

interface CanvasFocusProviderProps {
  children: ReactNode;
}

export const CanvasFocusProvider = ({ children }: CanvasFocusProviderProps) => {
  const focusFnRef = useRef<FocusCanvasOnNode | null>(null);

  const registerFocusCanvas = useCallback((fn: FocusCanvasOnNode | null) => {
    focusFnRef.current = fn;
  }, []);

  const focusCanvasOnSelectedNode = useCallback((nodeId: string) => {
    focusFnRef.current?.(nodeId);
  }, []);

  return (
    <CanvasFocusContext.Provider value={{ focusCanvasOnSelectedNode, registerFocusCanvas }}>
      {children}
    </CanvasFocusContext.Provider>
  );
};

export const useCanvasFocus = (): CanvasFocusContextValue => {
  return useContext(CanvasFocusContext);
};

export default CanvasFocusContext;
